/* eslint-disable max-len */
const NorticButtonShowcase = () => import(/* webpackChunkName: "norticbuttonshowcase" */ '@/components/public/showcase/nortic-button-showcase/NorticButtonShowcase.vue');
const NorticCheckboxShowcase = () => import(/* webpackChunkName: "norticcheckboxshowcase" */ '@/components/public/showcase/nortic-checkbox-showcase/NorticCheckboxShowcase.vue');
const SelectChipsShowcase = () => import(/* webpackChunkName: "selectchipsshowcase" */'@/components/public/showcase/select-ships-showcase/SelectChipsShowcase.vue');
const NorticTextInputShowcase = () => import(/* webpackChunkName: "nortictextinputshowcase" */ '@/components/public/showcase/nortic-input-showcase/NorticTextInputShowcase.vue');
const TabsShowcase = () => import(/* webpackChunkName: "tabsshowcase" */ '@/components/public/showcase/tabs-showcase/TabsShowcase.vue');
const ProgressBarShowcase = () => import(/* webpackChunkName: "progressbarshowcase" */ '@/components/public/showcase/progress-bar-showcase/ProgressBarShowcase.vue');
const ProgressCircleShowcase = () => import(/* webpackChunkName: "progresscircleshowcase" */ '@/components/public/showcase/progress-circle-showcase/ProgressCircleShowcase.vue');
const MessageShowcase = () => import(/* webpackChunkName: "messageshowcase" */ '@/components/public/showcase/message-showcase/MessageShowcase.vue');
const LoadingSkeletonShowcase = () => import(/* webpackChunkName: "loadingskeletonshowcase" */ '@/components/public/showcase/loading-skeleton-showcase/LoadingSkeletonShowcase.vue');
const ContentBoxShowcase = () => import(/* webpackChunkName: "contentboxshowcase" */ '@/components/public/showcase/content-box-showcase/ContentBoxShowcase.vue');
const ExpandableBulletShowcase = () => import(/* webpackChunkName: "expandablebulletshowcase" */ '@/components/public/showcase/expandable-bullet-showcase/ExpandableBulletShowcase.vue');
const ThemeShowcase = () => import(/* webpackChunkName: "themeshowcase" */ '@/components/public/showcase/theme-showcase/ThemeShowcase.vue');
const NorticIconButtonShowcase = () => import(/* webpackChunkName: "norticiconbuttonshowcase" */ '@/components/public/showcase/nortic-icon-button-showcase/NorticIconButtonShowcase.vue');
const NorticTabsShowcase = () => import(/* webpackChunkName: "nortictabsshowcase" */ '@/components/public/showcase/nortic-tabs-showcase/NorticTabsShowcase.vue');
const TabsHome = () => import(/* webpackChunkName: "tabshome" */ '@/components/public/showcase/tabs-showcase/subPages/TabsHome.vue');
const TabsPages = () => import(/* webpackChunkName: "tabspages" */ '@/components/public/showcase/tabs-showcase/subPages/TabsPages.vue');
const TabsPagesOne = () => import(/* webpackChunkName: "tabspagesone" */ '@/components/public/showcase/tabs-showcase/subPages/TabsPagesOne.vue');
const TabsPagesTwo = () => import(/* webpackChunkName: "tabspagestwo" */ '@/components/public/showcase/tabs-showcase/subPages/TabsPagesTwo.vue');
const NorticWysiwygEditorShowcase = () => import(/* webpackChunkName: "norticwysiwygedirshowcase" */ '@/components/public/showcase/nortic-wysiwyg-editor-showcase/NorticWysiwygEditorShowcase.vue');
const NorticWizardShowcase = () => import(/* webpackChunkName: "norticwizardshowcase" */ '@/components/public/showcase/nortic-wizard/NorticWizardShowcase.vue');
const EventSelectorShowcase = () => import(/* webpackChunkName: "eventselectorshowcase" */ '@/components/public/showcase/event-selector-showcase/EventSelectorShowcase.vue');
const SvgIconShowcase = () => import(/* webpackChunkName: "svgiconshowcase" */ '@/components/public/showcase/svg-icon-showcase/SvgIconShowcase.vue');
const NorticDatePickerShowcase = () => import(/* webpackChunkName: "nortidatepickershowcase" */ '@/components/public/showcase/nortic-date-picker-showcase/NorticDatePickerShowcase.vue');
const NorticTextAreaShowcase = () => import(/* webpackChunkName: "nortictextareashowcase" */ '@/components/public/showcase/nortic-text-area-showcase/NorticTextAreaShowcase.vue');
const GoogleAutoCompleteShowcase = () => import(/* webpackChunkName: "googleautocompleteshowcase" */ '@/components/public/showcase/google-auto-complete-showcase/GoogleAutoCompleteShowcase.vue');
const NorticAutoCompleteShowcase = () => import(/* webpackChunkName: "norticautocompleteshowcase" */ '@/components/public/showcase/nortic-auto-complete-showcase/NorticAutoCompleteShowcase.vue');
const NorticNumericInputShowcase = () => import(/* webpackChunkName: "nortinumericinputshowcase" */ '@/components/public/showcase/nortic-numeric-text-input/NorticNumericInputShowcase.vue');
const NorticRadioShowcase = () => import(/* webpackChunkName: "norticradioshowcase" */ '@/components/public/showcase/nortic-radio-showcase/NorticRadioShowcase.vue');
const NorticBadgeShowcase = () => import(/* webpackChunkName: "norticbadgeshowcase" */ '@/components/public/showcase/nortic-badge-showcase/NorticBadgeShowcase.vue');
const NorticCardShowcase = () => import(/* webpackChunkName: "norticcardshowcase" */ '@/components/public/showcase/nortic-card-showcase/NorticCardShowcase.vue');
const NorticDropdownButtonShowcase = () => import(/* webpackChunkName: "norticdropdownbuttonshowcase" */ '@/components/public/showcase/nortic-dropdown-button-showcase/NorticDropdownButtonShowcase.vue');
const NorticCardGridShowcase = () => import(/* webpackChunkName: "norticcardgridshowcase" */ '@/components/public/showcase/nortic-card-grid-showcase/NorticCardGridShowcase.vue');
const NorticListShowcase = () => import(/* webpackChunkName: "norticlistshowcase" */ '@/components/public/showcase/nortic-list-showcase/NorticListShowcase.vue');
const NorticSelectV2Showcase = () => import(/* webpackChunkName: "nortiseletv2showcase" */ '@/components/public/showcase/nortic-select-showcase/NorticSelectV2Showcase.vue');
const NorticDraggableListShowcase = () => import(/* webpackChunkName: "norticdraggablelistshowcase" */ '@/components/public/showcase/nortic-draggable-list-showcase/NorticDraggableListShowcase.vue');
const NorticTableShowcase = () => import(/* webpackChunkName: "nortictableshowcase" */ '@/components/public/showcase/nortic-table-showcase/NorticTableShowcase.vue');
const NorticDatePickerV2Showcase = () => import(/* webpackChunkName: "norticdatepickerv2showcase" */ '@/components/public/showcase/nortic-date-picker-showcase/NorticDatePickerV2Showcase.vue');
const NorticTimePickerShowcase = () => import(/* webpackChunkName: "nortictimepickershowcase" */ '@/components/public/showcase/nortic-time-picker-showcase/NorticTimePickerShowcase.vue');
const NorticDateTimePickerShowcase = () => import(/* webpackChunkName: "norticdatetimepickershowcase" */ '@/components/public/showcase/nortic-date-time-picker-showcase/NorticDateTimePickerShowcase.vue');
const NorticDialogShowcase = () => import(/* webpackChunkName: "norticdialogshowcase" */ '@/components/public/showcase/nortic-dialog-showcase/NorticDialogShowcase.vue');
const CompositionApiSaveableShowcase = () => import(/* webpackChunkName: "compositionApiSaveableShowcase" */ '@/components/public/showcase/composition-api-saveable-showcase/CompositionApiSaveableShowcase.vue');

const componentModules = {
  navigation: {
    tabs: {
      path: 'tabs',
      name: 'tabs',
      component: TabsShowcase,
    },
    norticTabs: {
      path: 'nortic-tabs',
      component: NorticTabsShowcase,
      children: [
        {
          path: '',
          name: 'norticTabs',
          component: TabsHome,
        },
        {
          path: 'pages',
          name: 'norticTabsPages',
          component: TabsPages,
          children: [
            {
              path: 'page-1',
              name: 'norticTabsPageOne',
              component: TabsPagesOne,
            },
            {
              path: 'page-2',
              name: 'norticTabsPageTwo',
              component: TabsPagesTwo,
            },
          ],
        },
      ],
    },
    norticWizard: {
      path: 'nortic-wizard',
      component: NorticWizardShowcase,
      children: [
        {
          path: '',
          name: 'norticWizard',
          component: TabsHome,
        },
        {
          path: 'pages',
          name: 'norticWizardPages',
          component: TabsPages,
          children: [
            {
              path: 'page-1',
              name: 'norticWizardPageOne',
              component: TabsPagesOne,
            },
            {
              path: 'page-2',
              name: 'norticWizardPageTwo',
              component: TabsPagesTwo,
            },
          ],
        },
      ],
    },
  },
  buttons: {
    norticButton: {
      path: 'nortic-button',
      name: 'norticButton',
      component: NorticButtonShowcase,
    },
    norticIconButton: {
      path: 'nortic-icon-button',
      name: 'norticIconButton',
      component: NorticIconButtonShowcase,
    },
    norticDropdownButton: {
      path: 'nortic-dropdown-button',
      name: 'norticDropdownButton',
      component: NorticDropdownButtonShowcase,
    },
  },
  input: {
    norticCheckbox: {
      path: 'nortic-checkbox',
      name: 'norticCheckbox',
      component: NorticCheckboxShowcase,
    },
    norticRadio: {
      path: 'nortic-radio',
      name: 'norticRadio',
      component: NorticRadioShowcase,
    },
    norticTextInput: {
      path: 'nortic-text-input',
      name: 'norticTextInput',
      component: NorticTextInputShowcase,
    },
    norticNumericTextInput: {
      path: 'nortic-numeric-input',
      name: 'norticNumericInput',
      component: NorticNumericInputShowcase,
    },
    norticTextArea: {
      path: 'nortic-text-area',
      name: 'norticTextArea',
      component: NorticTextAreaShowcase,
    },
    norticSelectV2: {
      path: 'nortic-select-v2',
      name: 'norticSelectV2',
      component: NorticSelectV2Showcase,
    },
    selectChips: {
      path: 'select-chips',
      name: 'selectChips',
      component: SelectChipsShowcase,
    },
    norticWysiwygEditor: {
      path: 'nortic-wysiwyg-editor',
      name: 'norticWysiwygEditor',
      component: NorticWysiwygEditorShowcase,
    },
    googleAutoComplete: {
      path: 'google-auto-complete',
      name: 'googleAutoComplete',
      component: GoogleAutoCompleteShowcase,
    },
    norticAutoComplete: {
      path: 'nortic-auto-complete',
      name: 'norticAutoComplete',
      component: NorticAutoCompleteShowcase,
    },
    norticDatePicker: {
      path: 'nortic-date-picker',
      name: 'norticDatePicker',
      component: NorticDatePickerShowcase,
    },
    norticDatePickerV2: {
      path: 'nortic-date-picker-v2',
      name: 'norticDatePickerV2',
      component: NorticDatePickerV2Showcase,
    },
    norticTimePicker: {
      path: 'notic-time-picker',
      name: 'norticTimePicker',
      component: NorticTimePickerShowcase,
    },
    norticDateTimePicker: {
      path: 'notic-date-time-picker',
      name: 'norticDateTimePicker',
      component: NorticDateTimePickerShowcase,
    },
  },
  content: {
    expandableBullet: {
      path: 'expandable-bullet',
      name: 'expandableBullet',
      component: ExpandableBulletShowcase,
    },
    norticTable: {
      path: 'nortic-table',
      name: 'norticTable',
      component: NorticTableShowcase,
    },
  },
  skeleton: {
    loadingSkeleton: {
      path: 'loading-skeleton',
      name: 'loadingSkeleton',
      component: LoadingSkeletonShowcase,
    },
  },
  layout: {
    contentBox: {
      path: 'content-box',
      name: 'contentBox',
      component: ContentBoxShowcase,
    },
    norticCard: {
      path: 'nortic-card',
      name: 'norticCard',
      component: NorticCardShowcase,
    },
    norticCardGrid: {
      path: 'nortic-card-grid',
      name: 'norticCardGrid',
      component: NorticCardGridShowcase,
    },
  },
  misc: {
    compositionApiSaveable: {
      path: 'composition-api-saveable',
      name: 'compositionApiSaveable',
      component: CompositionApiSaveableShowcase,
    },
    eventSelector: {
      path: 'event-selector',
      name: 'eventSelector',
      component: EventSelectorShowcase,
    },
    progressBar: {
      path: 'progress-bar',
      name: 'progressBar',
      component: ProgressBarShowcase,
    },
    progressCircle: {
      path: 'progress-circle',
      name: 'progressCircle',
      component: ProgressCircleShowcase,
    },
    message: {
      path: 'message',
      name: 'message',
      component: MessageShowcase,
    },
    badge: {
      path: 'badge',
      name: 'badge',
      component: NorticBadgeShowcase,
    },
    svgIcon: {
      path: 'svg-icon',
      name: 'svgIcon',
      component: SvgIconShowcase,
    },
    norticList: {
      path: 'nortic-list',
      component: NorticListShowcase,
      children: [
        {
          path: '',
          name: 'norticList',
          component: TabsHome,
        },
        {
          path: 'nortic-list-pages',
          name: 'norticListPages',
          component: TabsPagesOne,
        },
      ],
    },
    norticDraggableList: {
      path: 'nortic-draggable-list',
      name: 'norticDraggableList',
      component: NorticDraggableListShowcase,
    },
    norticConfirm: {
      path: 'nortic-confirm',
      name: 'norticConfirm',
      component: NorticDialogShowcase,
    },
  },
  theme: {
    themeVariables: {
      path: 'theme-variables',
      name: 'themeVariables',
      component: ThemeShowcase,
    },
  },
};

const getRouterChildren = () => Object.keys(componentModules)
  .flatMap((category) => Object.values(componentModules[category]));

const getCategories = () => Object.keys(componentModules);

const getSubcategories = (category) => Object.keys(componentModules[category]);

const getRouteName = (category, subcategory) => {
  if (!componentModules[category][subcategory].name) {
    return componentModules[category][subcategory].children[0].name;
  }

  return componentModules[category][subcategory].name;
};

export {
  getRouterChildren,
  getCategories,
  getSubcategories,
  getRouteName,
};
